import { PassiveOperatorWarning } from '@/components/atoms/PassiveOperatorWarning';
import { gameCancelBlockedAction } from './gameCancelBlockedAction';

/** #1428: disclosure only; this component never selects or cancels orders. */
export function GameCancelWarning({ messages, usBlocked }: {
  messages: readonly string[];
  usBlocked: boolean;
}) {
  if (messages.length === 0) return null;
  return (
    <PassiveOperatorWarning
      severity="defect"
      className="mb-1.5"
      showIcon={false}
      title="Cannot safely cancel this game"
      explanation={
        <details>
          <summary className="cursor-pointer rounded focus-visible:outline focus-visible:outline-2">
            {messages.length} {messages.length === 1 ? 'issue needs' : 'issues need'} attention — details
          </summary>
          <div role="region" aria-label="Game cancellation issues" tabIndex={0}
            className="mt-1 max-h-40 space-y-2 overflow-y-auto overscroll-contain break-words [overflow-wrap:anywhere]">
            {messages.map((message, i) => <p key={`${i}-${message}`}>{message}</p>)}
          </div>
        </details>
      }
      action={gameCancelBlockedAction(usBlocked)}
    />
  );
}
